export const getPaths = state => state.paths;
export const getSavedSearchIndexPath = state => state.paths.savedSearches;